import { Alert } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

type Props = {
    onCancel: () => void;
    onConfirm: () => void;
};

/**
 * Shown inside the report wizard's anamnesis upload step when the patient already
 * has an anamnesis written in-app. Uploading a file replaces that inline document,
 * so we ask for an explicit confirmation first.
 */
export default function AnamnesisOverrideConfirmAlert({ onCancel, onConfirm }: Props) {
    return (
        <Alert variant="warning" className="text-xs">
            <div className="space-y-2">
                <p>
                    Você já escreveu uma anamnese para este paciente no LaudoPsi. Enviar um arquivo
                    vai substituí-la.
                </p>
                <div className="flex justify-end gap-2">
                    <Button size="sm" variant="outline" onClick={onCancel}>
                        Cancelar
                    </Button>
                    <Button size="sm" onClick={onConfirm}>
                        Substituir
                    </Button>
                </div>
            </div>
        </Alert>
    );
}
